import axios from 'axios';
import Cookie from 'js-cookie';

const baseURL = process.env.REACT_APP_API_BASE_URL || '';
const internalKey = process.env.REACT_APP_INTERNAL_API_KEY || '';

if (baseURL) {
  axios.defaults.baseURL = baseURL;
}

axios.interceptors.request.use(
  (config) => {
    const token = Cookie.get('token');
    if (!config.headers) {
      config.headers = {};
    }
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (internalKey && !config.headers['X-Internal-Key']) {
      config.headers['X-Internal-Key'] = internalKey;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;
